const urlPrefix = `/IlocosSur/Legislative/api`;
var vRecID;
let news_tbl;

const homeMethod = (_url) => {
    return new Promise(resolve => {
        var settings = {
            "url": `${urlPrefix}/leg-track/${_url}`,
            "method": "POST",
            "data": {},
            "headers": {
                /* "Content-Type": "application/json" */
            }
        };
        $.ajax(settings)
            .always(function(msg) {
                resolve(msg);
            });
    });
}


$(() => {
    homeMethod('get-slider').then((data) => {
        if (data.success) {


            var slide, title, desc, id;
            var element = "";
            var element2 = "";
            var counter = 0;
            $.each(data, function(i, record) {
                for (var i in record) {
                    counter++;

                    slide = '<div class="carousel-item h-100 bg-slider" id="slide-' + record[i].id + '">';
                    opacity = '<div class="row h-100 align-items-center bg-primary bg-opacity-' + record[i].opacity + '">';
                    title = '<p class="fs-1 fw-semibold text-hdr lh-sm ls-3 text-white mb-2 text-uppercase px-5">' + record[i].title + '</p>';
                    desc = '<p class="fs-5 ls-6 text-hdr text-warning mt-6">' + record[i].desc + '</p>';


                    element = slide + opacity + '<div class="row h-100 align-items-center"><div class="col-md-auto mx-auto text-center">' + title + desc + '</div></div></div></div>';
                    element2 = '<button type="button" data-bs-target="#home-slider" data-bs-slide-to="' + counter + '" aria-current="true" aria-label="Slide ' + record[i].id + '"></button>'

                    $(".carousel-inner").append(element);
                    $(".carousel-indicators").append(element2);

                    $('#slide-' + record[i].id).css("background-image", "url('/IlocosSur/slider/" + record[i].name + "')");
                }
            });

        } else {
            _notif("error", data.message);
        }

        news_tbl = $('#news_tbl').DataTable({
            columnDefs: [{
                    "target": 0,
                    "className": "text-center px-1"
                },
                {
                    "target": 1,
                    "className": "fs-7"
                }
            ],
            'columns': [
                { "data": 'date' },
                { "data": 'title' }
            ],
            'createdRow': function(row, data, dataIndex) {
                $(row).attr('id', data.id);
            },
            "length": false,
            "filter": false,
            "info": false,
            "paging": false,
            "ordering": false,
        });
        homeMethod('get-homenews', JSON.stringify({})).then((dts) => {
            news_tbl.rows().clear();
            news_tbl.rows.add(dts.data).draw();
        })
        $('#news_tbl tbody').on('click', 'tr', function() {

            let data = news_tbl.row(this).data();

            $("#news-title").html(data.title);
            $("#news-date").html(data.date);

            if (data.img == "") {
                $("#news-image").addClass("d-none");
            } else {
                $("#news-image").removeClass("d-none");
                $("#news-image").attr("src", "/IlocosSur/news/" + data.img);
            }

            $("#news-body").html(data.desc);

            $("#newsModal").modal("show");
        });


    });




});